import List from "@/components/treeList";
import Bus from "./Bus.js";

const Table = args => {
  // 新增子类
  function handleChild({ id }) {
    Bus.$emit("addLecturer", id);
  }

  // 编辑
  function handleUpdate({ id }) {
    Bus.$emit("updateLecturer", id);
  }

  //删除
  function handleDelete({ id }) {
    Bus.$emit("lecturerTypeDelete", id);
  }

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["编辑", () => handleUpdate(vo.row), "icon-edit", "lecturerType:update"],
      ["删除", () => handleDelete(vo.row), "icon-delete", "lecturerType:delete"]
    ];
    if (vo.row.pid == 0) {
      dealConf.unshift([
        "新增子类",
        () => handleChild(vo.row),
        "icon-add",
        "lecturerType:save"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const DealStyle = ({ props: { vo } }) => {
    const dealConf = [];
    if (!vo.row.children) {
      dealConf.push(["el-icon-minus"]);
      return (
        <div>
          {dealConf.map(item => (
            <i
              class={item[0]}
              style="width: 20px; height: 20px; margin-right: 3px; text-align: center;"
            ></i>
          ))}
          <span>{vo.row.name}</span>
        </div>
      );
    } else {
      return <span>{vo.row.name}</span>;
    }
  };

  const AccountTableConfig = [
    {
      label: "分类名称",
      prop: "name",
      minWidth: "200",
      render: vo => <DealStyle vo={vo} />
    },
    {
      label: "教师数量",
      prop: "key",
      minWidth: "150"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "160"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "160",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
